/**
 * Icon Component - Thay thế emoji bằng SVG icons
 * Sử dụng Unicode symbols đơn giản hoặc có thể tích hợp icon library sau
 */

import React from 'react';
import './Icon.css';

// Icon map sử dụng Unicode symbols (có thể thay bằng SVG hoặc icon library)
const iconMap = {
  // Location & Navigation
  location: '📍',
  locationOn: '📍',
  refresh: '🔄',
  navigate: '🧭',
  
  // Camera & Media
  camera: '📷',
  cameraAlt: '📸',
  image: '🖼️',
  
  // Actions
  check: '✓',
  checkCircle: '✅',
  close: '✕',
  closeCircle: '❌',
  add: '+',
  remove: '−',
  delete: '🗑️',
  
  // Navigation
  logout: '🚪',
  history: '📋',
  home: '🏠',
  back: '←',
  forward: '→',
  menu: '☰',
  
  // Status
  warning: '⚠️',
  info: 'ℹ️',
  error: '❌',
  success: '✅',
  
  // Time
  time: '🕐',
  calendar: '📅',
  clock: '⏰',
  
  // User
  user: '👤',
  users: '👥',
  
  // Other
  settings: '⚙️',
  search: '🔍',
  filter: '🔽',
  download: '⬇️',
  upload: '⬆️',
};

const Icon = ({ 
  name, 
  size = 20, 
  color, 
  className = '',
  ariaLabel,
  ...props 
}) => {
  const iconChar = iconMap[name];
  
  if (!iconChar) {
    console.warn(`Icon "${name}" not found`);
    return null;
  }
  
  return (
    <span
      className={`icon icon-${name} ${className}`}
      style={{
        fontSize: `${size}px`,
        color: color,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: 1,
      }}
      aria-label={ariaLabel}
      role={ariaLabel ? 'img' : 'presentation'}
      {...props}
    >
      {iconChar}
    </span>
  );
};

export default Icon;
